import type { ComponentMode, Role } from 'types';

interface State extends Role {
  mode: ComponentMode;
  defaultName: string;
}
const initialState: Partial<State> = {};

type Action = undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
